module.exports = __webpack_public_path__ + "media/bootstrap-icons/question-octagon-65f3cde2.svg";